
import { Options, prop, Vue } from "vue-class-component";
import UploadPhotoCodReconcile from "./upload-photo-cod-reconcile.vue";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import {
  DeleteHydraFileRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

class Props {
  modelValue = prop<any>({
    required: true
  });
  iconTitle = prop<boolean>({
    default: true,
    type: Boolean
  });
  reconcileFor = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  emits: ["onSuccessUploadImage", "onSuccessDeleteImage", "preview"],
  components: {
    UploadPhotoCodReconcile
  }
})
export default class SectionUploadPhotoCodReconcile extends Vue.with(Props) {
  attachmentImage: string[] = [];
  isError = false;

  mounted() {
    this.attachmentImage = [...this.modelValue];
  }

  async onUpload(file: any) {
    if (!file.file) return;
    this.isError = false;

    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: file.file,
          folderPath: "cod_reconcile_courier_note/",
          reconcileFor: this.reconcileFor
        })
      );
      this.attachmentImage[file.index] = fileLink.data;
      this.$emit("update:modelValue", this.attachmentImage);
      this.$emit("onSuccessUploadImage", {
        url: this.attachmentImage[file.index],
        index: file.index
      });
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemove(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.attachmentImage[index]],
          folderPath: "cod_reconcile_courier_note/"
        })
      );
      const statusDel = res.data[this.attachmentImage[index]];

      if (statusDel) {
        const statusDel = res.data[this.attachmentImage[index]];

        if (statusDel) {
          this.attachmentImage[index] = "";
          this.$emit("update:modelValue", this.attachmentImage);
          this.$emit("onSuccessDeleteImage", {
            url: this.attachmentImage[index],
            index
          });
        }
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("codReconcile.dailyDeposit.failDeletePhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  onPreview(index: number) {
    this.$emit("preview", index);
  }

  onError() {
    this.isError = true;
  }
}
